(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["country-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements.get('country-switcher')) return;

    class CountrySwitcher extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-country-switcher-toggle]');
        this.panel = this.querySelector('[data-country-switcher-panel]');
        if (!this.toggle || !this.panel) return;

        this.onToggleClick = this.onToggleClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);

        this.toggle.addEventListener('click', this.onToggleClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('focusout', this.onFocusOut);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      get options() {
        return Array.prototype.slice.call(this.panel.querySelectorAll('[data-country-switcher-option]'));
      }

      isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      open(focusTarget) {
        if (this.isOpen()) return;
        this.panel.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        this.classList.add('is-open');
        document.addEventListener('click', this.onDocumentClick);
        var options = this.options;
        var active = this.panel.querySelector('.country-switcher__option.is-active');
        var target = focusTarget === 'last' ? options[options.length - 1] : (active || options[0]);
        if (target) target.focus();
      }

      close(returnFocus) {
        if (!this.isOpen()) return;
        this.panel.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        this.classList.remove('is-open');
        document.removeEventListener('click', this.onDocumentClick);
        if (returnFocus) this.toggle.focus();
      }

      onToggleClick(event) {
        event.preventDefault();
        if (this.isOpen()) {
          this.close(true);
        } else {
          this.open();
        }
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close(false);
      }

      onFocusOut(event) {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
      }

      onKeydown(event) {
        var key = event.key;
        if (key === 'Escape' && this.isOpen()) {
          event.preventDefault();
          this.close(true);
          return;
        }
        if (event.target === this.toggle && !this.isOpen() && (key === 'ArrowDown' || key === 'ArrowUp')) {
          event.preventDefault();
          this.open(key === 'ArrowUp' ? 'last' : undefined);
          return;
        }
        if (!this.isOpen()) return;
        var options = this.options;
        var index = options.indexOf(document.activeElement);
        if (index === -1) return;
        var next = null;
        if (key === 'ArrowDown') next = options[(index + 1) % options.length];
        if (key === 'ArrowUp') next = options[(index - 1 + options.length) % options.length];
        if (key === 'Home') next = options[0];
        if (key === 'End') next = options[options.length - 1];
        if (next) {
          event.preventDefault();
          next.focus();
        }
      }
    }

    window.customElements.define('country-switcher', CountrySwitcher);
  })();
  } catch(e) { console.error(e); }
})();

})();
